<template>
  <v-container class="content">
    <!--loading screen when add video request is being handled-->
    <LoadingScreen :loading="loading" />

    <div class="nav" @click="goBack">
      <v-icon size="12px" color="#00457C">arrow_back_ios</v-icon> Back
    </div>
    <div class="header text-left">Create Promotions</div>

    <v-row class="photo-label" style="padding-bottom: 0">
      <v-col cols="10">
        <label for="cover-photo">Cover Photo</label>
      </v-col>
    </v-row>
    <v-row class="photo-picker">
      <v-col cols="10">
        {{ imageFileName }}
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <label for="created">Created By</label>
        <input
          id="created"
          type="text"
          v-model="createdBy"
          @input="$v.createdBy.$touch()"
        /><br />
        <div
          class="error-msg"
          v-show="$v.createdBy.$invalid && $v.createdBy.$dirty"
        >
          This is a required field.
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <label for="name">Promotion Code</label>
        <input
          id="name"
          type="text"
          v-model="name"
          @input="$v.name.$touch()"
        /><br />
        <div class="error-msg" v-show="$v.name.$invalid && $v.name.$dirty">
          This is a required field.
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        <label for="code">Promotion Description</label>
        <input
          id="code"
          type="text"
          v-model="code"
          @input="$v.code.$touch()"
        /><br />
        <div class="error-msg" v-show="$v.code.$invalid && $v.code.$dirty">
          This is a required field.
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <label for="percentDiscount"
          >Limit (No. of codes that can be used for redemption)</label
        >
        <input type="text" v-model="limit" @input="$v.limit.$touch()" /><br />
        <div class="error-msg" v-show="$v.limit.$invalid && $v.limit.$dirty">
          Please enter a number.
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <label for="ann-btn-url">Promo Type</label>
        <select v-model="promoType" label="Select">
          <option>Retail</option>
          <option>Pawn</option>
        </select>
      </v-col>
    </v-row>

    <!-- Button Configurations -->
    <v-row>
      <v-col cols="12" md="6">
        <label for="ann-btn-title">Button Title</label>
        <input
          id="ann-btn-title"
          type="text"
          v-model="btnTitle"
          @input="$v.btnTitle.$touch()"
        />
        <!-- <div class="error-msg" v-show="$v.btnTitle.$invalid && $v.btnTitle.$dirty">This is a required field.</div> -->
      </v-col>
    </v-row>

    <v-row class="date-labels">
      <v-col cols="6" md="3">
        <label for="startDate">Start Date</label>
      </v-col>
      <v-col cols="6" md="3">
        <label for="startDate">{{ startDate }}</label>
      </v-col>
      <v-col cols="6" md="3">
        <input
          type="datetime-local"
          id="startDate"
          v-model="startDate"
          @input="$v.startDate.$touch()"
        />
      </v-col>
    </v-row>
    <v-row class="date-pickers">
      <v-col cols="6" md="3">
        <label for="endDate">End Date</label>
      </v-col>
      <v-col cols="6" md="3">
        <label for="endDate">{{ endDate }}</label>
      </v-col>
      <v-col cols="6" md="3">
        <input
          type="datetime-local"
          id="endDate"
          v-model="endDate"
          @input="$v.endDate.$touch()"
        />
        <div
          class="error-msg"
          v-show="$v.endDate.$invalid && $v.endDate.$dirty"
        >
          End date has to be at least one day from start date.
        </div>
      </v-col>
    </v-row>

    <hr />

    <!-- Claim Notif -->
    <div class="header text-left">Claim Notification</div>
    <v-row>
      <v-col cols="12">
        <label for="msg-title">Notification Title</label>
        <input id="msg-title" type="text" v-model="claim_notif_title" />
        <br />
      </v-col>
    </v-row>

    <!-- Content -->
    <v-row>
      <v-col cols="12">
        <label for="msg-content">Notification Content</label>
        <textarea id="msg-content" v-model="claim_notif_content"></textarea>
      </v-col>
    </v-row>

    <!-- Title -->
    <v-row>
      <v-col cols="12">
        <label for="msg-title">Inbox Title</label>
        <input id="msg-title" type="text" v-model="claim_title" />
        <br />
      </v-col>
    </v-row>

    <!-- Content -->
    <v-row>
      <v-col cols="12">
        <label for="msg-content">Inbox Content</label>
        <!-- <textarea id="msg-content" v-model="content" @input="$v.content.$touch()"></textarea> -->
        <quill-editor
          id="msg-content"
          :content="claim_content"
          class="editor-layout"
          @change="onEditorChange($event, 'claim_content')"
        />
      </v-col>
    </v-row>

    <hr />

    <!-- Redeem Notif -->
    <div class="header text-left">Redeem Notification</div>
    <v-row>
      <v-col cols="12">
        <label for="msg-title">Notification Title</label>
        <input id="msg-title" type="text" v-model="redeem_notif_title" />
        <br />
      </v-col>
    </v-row>

    <!-- Content -->
    <v-row>
      <v-col cols="12">
        <label for="msg-content">Notification Content</label>
        <textarea id="msg-content" v-model="redeem_notif_content"></textarea>
      </v-col>
    </v-row>

    <!-- Title -->
    <v-row>
      <v-col cols="12">
        <label for="msg-title">Inbox Title</label>
        <input id="msg-title" type="text" v-model="redeem_title" />
        <br />
      </v-col>
    </v-row>

    <!-- Content -->
    <v-row>
      <v-col cols="12">
        <label for="msg-content">Inbox Content</label>
        <!-- <textarea id="msg-content" v-model="content" @input="$v.content.$touch()"></textarea> -->
        <quill-editor
          id="msg-content"
          :content="redeem_content"
          class="editor-layout"
          @change="onEditorChange($event, 'redeem_content')"
        />
      </v-col>
    </v-row>

    <v-row class="date-pickers">
      <v-col cols="6" md="3">
        <label for="endDate">Expiry Date</label>
      </v-col>
      <v-col cols="6" md="3">
        <label for="endDate">{{ expiryDate }}</label>
      </v-col>
      <v-col cols="6" md="3">
        <input type="datetime-local" id="endDate" v-model="expiryDate" />
      </v-col>
    </v-row>

    <hr />
    <v-row>
      <v-col cols="6" md="3">
        <v-btn
          :disabled="$v.$invalid"
          color="#00457C"
          @click="submitPromotionsForm"
          >Submit</v-btn
        >
      </v-col>
      <v-col cols="4" md="3">
        <v-btn color="#00457C" :disabled="$v.$invalid" @click="preview"
          >Preview</v-btn
        >
      </v-col>
    </v-row>
    <v-row v-if="success">
      <v-col cols="12">
        <v-alert type="success">Promotion added successfully.</v-alert>
      </v-col>
    </v-row>

    <v-row v-if="error">
      <v-col cols="12">
        <v-alert type="error">Error occurred. Please try again.</v-alert>
      </v-col>
    </v-row>

    <!--popup when user clicks on view-->
    <v-dialog
      v-if="promoPreview"
      v-model="promoPreview"
      max-width="450px"
      overlay-opacity="0"
    >
      <v-card class="promo">
        <div
          class="discount"
          :style="{
            backgroundImage: 'url(' + promoPreviewDetails.imgUrl + ')',
          }"
        ></div>
        <div class="promo-text">
          <div>{{ promoPreviewDetails.name }}</div>
          <div>{{ promoPreviewDetails.code }}</div>
        </div>
        <div class="cta">
          <div v-if="promoPreviewDetails.promoType == 'Retail'">
            <img src="@/assets/luxestyle-promotion.png" width="50%" />
          </div>
          <div v-else>
            <img src="@/assets/pawn-promotion.png" width="80%" />
          </div>
          <button>{{ promoPreviewDetails.btnTitle }}</button>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import LoadingScreen from "./commons/LoadingScreen";

//form validation: check if end date falls after start date
let checkEndDate = (value, vm) => {
  let startDate = new Date(vm.startDate).getTime();
  let input = new Date(value).getTime();

  if (input > startDate) {
    return true;
  } else {
    return false;
  }
};

export default {
  components: {
    LoadingScreen,
  },

  data() {
    return {
      name: "",
      code: "",
      percentDiscount: "0",
      startDate: null,
      endDate: null,
      createdBy: "",
      loading: false,
      success: false,
      error: false,
      limit: 0,
      imageFile: null,
      imageFileName: null,
      btnTitle: "",
      promoType: "Retail",
      promoPreview: false,
      promoPreviewDetails: null,
      claim_notif_title: "",
      claim_notif_content: "",
      claim_title: "",
      claim_content: "",
      redeem_notif_title: "",
      redeem_notif_content: "",
      redeem_title: "",
      redeem_content: "",
      expiryDate: null,
      selectedId: this.$route.params.itemId,
    };
  },

  //rules for validation
  validations: {
    name: {
      required,
    },

    code: {
      required,
    },

    limit: {
      required,
    },

    startDate: {
      required,
    },

    createdBy: {
      required,
    },

    endDate: {
      checkEndDate,
    },
  },

  mounted() {
    axios
      .get(
        process.env.VUE_APP_HOST_SERVER + "/api/promotions/" + this.selectedId
      )
      .then((res) => this.processFetchedData(res.data))
      .catch((err) => console.log(err));
  },

  methods: {
    onEditorChange({ quill, html, text }, type) {
      console.log("editor change!", quill, html, text);
      if (type == "claim_content") {
        this.claim_content = html;
      } else {
        this.redeem_content = html;
      }
    },
    closeMsgDialog() {
      this.promoPreview = false;
      this.promoPreviewDetails = null;
    },
    clickImageInput() {
      this.$refs.imageFileInput.click();
    },

    preview() {
      this.promoPreview = true;
      this.promoPreviewDetails = {
        name: this.name,
        code: this.code,
        promoType: this.promoType,
        imgUrl: this.imageFileName,
        btnTitle: this.btnTitle,
      };
    },
    processFetchedData(rawData) {
      this.name = rawData.name;
      this.code = rawData.code;
      this.percentDiscount = rawData.percentDiscount;
      this.createdBy = rawData.createdBy;
      this.startDate = new Date(rawData.dateTimeStart._seconds * 1000)
        .toISOString()
        .slice(0, 10);
      this.endDate = new Date(rawData.dateTimeEnd._seconds * 1000)
        .toISOString()
        .slice(0, 10);
      this.enabled = rawData.isEnabled;
      this.imageFileName = rawData.imgUrl;
      this.limit = rawData.limit;
      this.startDate = new Date(rawData.dateTimeStart._seconds * 1000);
      this.endDate = new Date(rawData.dateTimeEnd._seconds * 1000);
      this.btnTitle = rawData.btnTitle;
      this.claim_notif_title = rawData.claim_notif_title;
      this.claim_notif_content = rawData.claim_notif_content;
      this.claim_title = rawData.claim_title;
      this.claim_content = rawData.claim_content;
      this.redeem_notif_title = rawData.redeem_notif_title;
      this.redeem_notif_content = rawData.redeem_notif_content;
      this.redeem_title = rawData.redeem_title;
      this.redeem_content = rawData.redeem_content;
      this.expiryDate = rawData.expiryDate.toLocaleString();
    },

    submitPromotionsForm() {
      // this.loading = true; //enable loading screen once user clicks submit

      const promotionDetails = {
        id: this.selectedId,
        promoType: this.promoType,
        imgUrl: this.imageFileName,
        name: this.name,
        code: this.code,
        limit: this.limit,
        btnTitle: this.btnTitle,
        startDateTime: this.startDate,
        endDateTime: this.endDate,
        createdBy: this.createdBy,
        updatedDateTime: new Date(),
        claim_notif_title: this.claim_notif_title,
        claim_notif_content: this.claim_notif_content,
        claim_title: this.claim_title,
        claim_content: this.claim_content,
        redeem_notif_title: this.redeem_notif_title,
        redeem_notif_content: this.redeem_notif_content,
        redeem_title: this.redeem_title,
        redeem_content: this.redeem_content,
        isEnabled: false, //promo codes will always be disabled at time of creation since the earliest date they can start is the next day. TODO: date validations
        expiryDate: this.expiryDate,
      };

      axios
        .post(
          process.env.VUE_APP_HOST_SERVER + "/api/promotions/save",
          promotionDetails
        )
        .then(() => {
          this.loading = false; //disable loading screen once request is handled
          this.success = true; //show success message
          this.error = false;
        })
        .catch((err) => {
          console.log(err);
          this.error = true;
        });
    },

    deletePromotionsItem() {
      this.dialog = true;
    },

    confirmDeleteItem() {
      this.dialog = false;

      axios
        .post(process.env.VUE_APP_HOST_SERVER + "/api/promotions/delete", {
          id: this.selectedId,
        })
        .then(() => {
          this.loading = false; //disable loading screen once request is handled;
          this.goBack(); //go back to overview page once video is deleted
          this.error = false;
        })
        .catch((err) => {
          console.log(err);
          this.error = true;
        });
    },

    goBack() {
      this.$router.push({ name: "HomepagePromotions" }).catch(() => {});
    },
  },
};
</script>

<style scoped>
.content {
  box-shadow: 0px 1px 20px rgba(163, 163, 163, 0.25);
  border: 1px solid #eeeeee;
  padding: 25px;
  text-align: initial;
}

.content .row {
  padding-bottom: 18px;
}

.content .row:nth-last-child(1) {
  padding-bottom: 0;
}

.content .nav {
  color: #00457c;
  font-weight: bold;
  padding-bottom: 16px;
  border-bottom: 1px solid #efefef;
  margin-bottom: 25px;
  font-size: 16px;
  cursor: pointer;
  width: 100%;
}

.content .header {
  font-size: 26px;
  margin-bottom: 20px;
  font-weight: normal;
}

.content button {
  width: 100%;
  font-size: 14px;
  font-weight: normal;
  color: white;
  text-transform: none;
  letter-spacing: normal;
}

label,
.label {
  font-size: 14px;
  color: #6f6f6f;
  margin-bottom: 10px;
  display: block;
}

.content .date-labels,
.content .date-labels > div,
.radio-btns > div {
  padding-bottom: 0;
}

.content .date-pickers > div,
.radio-btns > div {
  padding-top: 0;
}

label#browse-btn {
  display: inline-block;
  background: #ffffff;
  box-shadow: 0px 1px 5px rgba(120, 120, 120, 0.25);
  border-radius: 5px;
  color: #9b9b9b;
  padding: 10px;
  margin-bottom: 0;
}

input[type="text"],
input[type="number"],
input[type="date"],
textarea {
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  width: 100%;
  font-size: 14px;
}

.error-msg {
  font-size: 10px;
  color: #ea6254;
  margin-top: 5px;
}

.discount {
  background-size: contain;
  width: 150px;
}

.discount > div:nth-child(2) {
  width: 30px;
  font-size: 16px;
  line-height: 1;
}

.promo-text {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  padding: 0 13px;
  color: black;
}

.promo-text > div:first-child {
  font-size: 16px;
}

.promo-text > div:nth-child(2) {
  font-size: 12px;
}
.promo {
  width: 100%;
  height: 140px;
  border-radius: 8px;
  display: grid;
  grid-template-columns: 3fr 5fr 4fr;
}

.cta {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  padding-right: 10px;
}

.cta > div {
  font-size: 12px;
  color: #9b9b9b;
  margin-bottom: 10px;
  text-align: center;
}

.cta > button {
  font-size: 12px;
  border: none;
  padding: 8px 30px;
  background: #2f80ed;
  border-radius: 25px;
  color: white;
}
</style>
